import React from 'react';
import { Church, ScanSearch, BookOpen, PlusCircle, Heart, Disc3, Folder, Album } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: Church, label: 'Inicio', path: '/' },
    { icon: ScanSearch, label: 'Buscar', path: '/search' },
    { icon: BookOpen, label: 'Tu Biblioteca', path: '/library' }
  ];

  const libraryItems = [
    { icon: PlusCircle, label: 'Crear Playlist', path: '/create-playlist' },
    { icon: Heart, label: 'Canciones que te gustan', path: '/liked' },
    { icon: Album, label: 'Tus Álbumes', path: '/albums' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="hidden md:flex md:w-64 bg-white border-r border-gray-200 h-full flex-col shadow-lg">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <img 
          src="https://customer-assets.emergentagent.com/job_worship-tracks-5/artifacts/twg4kldp_LOGO%20Iglesia%202.png" 
          alt="Tu Iglesia App" 
          className="w-40 transition-transform duration-300 hover:scale-105"
        />
      </div>

      {/* Main Menu */}
      <nav className="px-3 mb-8 mt-4">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 transform ${
                isActive(item.path)
                  ? 'bg-gradient-to-r from-[#00CCFF] to-[#056A84] text-white shadow-lg scale-105'
                  : 'text-gray-700 hover:text-[#00CCFF] hover:bg-gray-50 hover:scale-102'
              }`}
            >
              <Icon size={22} strokeWidth={2.5} />
              <span className="font-semibold text-sm">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Library Section */}
      <div className="px-3 flex-1 overflow-y-auto">
        <div className="border-t border-gray-200 pt-4">
          {libraryItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 transform ${
                  isActive(item.path)
                    ? 'bg-gradient-to-r from-[#00CCFF] to-[#056A84] text-white shadow-lg scale-105'
                    : 'text-gray-600 hover:text-[#00CCFF] hover:bg-gray-50 hover:scale-102'
                }`}
              >
                <Icon size={20} />
                <span className="text-sm">{item.label}</span>
              </button>
            );
          })}
        </div>

        {/* Playlists */}
        <div className="mt-6 space-y-2">
          <div className="flex items-center gap-2 px-4 py-2">
            <Folder size={20} className="text-[#056A84]" />
            <span className="text-[#056A84] text-xs font-bold uppercase tracking-wide">Mis Playlists</span>
          </div>
          {['Adoración Matutina', 'Worship en Español', 'Momento de Oración', 'Nuevos Lanzamientos'].map((playlist, idx) => (
            <button
              key={idx}
              onClick={() => navigate(`/playlist/${idx + 1}`)}              className="w-full text-left px-4 py-2 text-sm text-gray-600 hover:text-[#00CCFF] hover:bg-gray-50 rounded-lg transition-all duration-200 transform hover:translate-x-1 flex items-center gap-2"
            >
              <Disc3 size={14} className="text-gray-400" />
              {playlist}
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <p className="text-xs text-gray-400 text-center font-medium">
          Tu aliado en el Ministerio de Cristo
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
